interface CustomWindow extends Window {
    __DEBUG_FORCE_INTERACTION_REQUIRED?: boolean;
    simulateAuthError?: (enable: boolean) => boolean;
    corruptToken?: () => boolean;
}

export const simulateAuthError = (enable = true) => {
    if (import.meta.env.VITE_ENVIRONMENT === "dev") {
        (window as CustomWindow).__DEBUG_FORCE_INTERACTION_REQUIRED = enable;
        return enable;
    }
    console.warn("Auth simulation is only available in development mode");
    return false;
};

export const corruptToken = () => {
    try {
        const allKeys = Object.keys(localStorage);
        const tokenKeys = allKeys.filter((key) => key.includes("login.windows.net-idtoken"));

        if (tokenKeys.length === 0) {
            return false;
        }

        let corrupted = false;

        for (const key of tokenKeys) {
            try {
                const rawData = localStorage.getItem(key);
                if (!rawData) continue;

                const data = JSON.parse(rawData);
                if (data?.secret) {
                    data.secret = data.secret.substring(0, data.secret.length - 1);
                    localStorage.setItem(key, JSON.stringify(data));
                    corrupted = true;
                }
            } catch (error) {
                console.error(`Error processing token ${key}:`, error);
            }
        }

        return corrupted;
    } catch (error) {
        console.error("Error corrupting token:", error);
        return false;
    }
};
